import { BodyPrimary } from '@liveauctioneers/caterwaul-components/lib/Text/Text/TextComponents';

import { PerformanceLog } from '@/redux/modules/apiPerformanceStats';

type ApiStatsSummaryProps = {
    apiLog: PerformanceLog | null;
};

export const ApiStatsSummary = ({ apiLog }: ApiStatsSummaryProps) => {
    if (!apiLog) {
        return null;
    }

    return (
        <section className="m-xs flex flex-col border border-border-black p-xs">
            <BodyPrimary>url: {apiLog.url}</BodyPrimary>
            <BodyPrimary>requests: {apiLog.stats.numRequests}</BodyPrimary>
            <BodyPrimary>waterfalls: {apiLog.stats.numWaterfalls}</BodyPrimary>
            <BodyPrimary>total time: {Math.round(apiLog.stats.totalFetchTime)}ms</BodyPrimary>
        </section>
    );
};
